// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatBubbleIcon_container__2OxSY","container__icon":"ChatBubbleIcon_container__icon__shF_V"};